<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Vijesti</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <v-row align="center" class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Vijesti</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="6" class="px-3">
                    <v-switch v-model="notification" inset label="Notifikacije"></v-switch>
                </v-col>
                <v-col cols="6" class="px-3">
                    <v-switch v-model="selectedItem.status" inset label="Status"></v-switch>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-select clearable
                              :items="categories"
                              v-model="selectedItem.category"
                              dense
                              label="Kategorija **"
                              outlined
                              item-value="id"
                              item-text="name"
                              return-object
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="selectedItem.publish_date"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="selectedItem.publish_date"
                                    outlined
                                    dense
                                    label="Datum objavljivanja"
                                    readonly
                                    v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="12" sm="6" class="px-2">
                    <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :return-value.sync="selectedItem.annunciation_date"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="selectedItem.annunciation_date"
                                    outlined
                                    dense
                                    label="Datum najave"
                                    readonly
                                    v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="date2" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menu2.save(date2)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="12" sm="6" class="px-2">
                    <v-select clearable
                              v-model="selectedItem.highlighted"
                              :items="[{text: 'DA', value: 1}, {text: 'NE', value: 0}]"
                              dense
                              label="Izdvojene vijesti"
                              outlined
                              item-value="value"
                              item-text="text"
                    ></v-select>
                </v-col>
                <v-col cols="12">
                    <v-row no-gutters>
                        <v-col cols="6">
                            <v-col cols="12" sm="12" class="px-2 py-0">
                                <v-select clearable
                                          v-model="selectedItem.slider"
                                          :items="[{text: 'DA', value: 1}, {text: 'NE', value: 0}]"
                                          dense
                                          label="Slajder"
                                          outlined
                                          item-value="value"
                                          item-text="text"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" class="px-2 py-0">
                                <v-file-input
                                        v-model="selectedItem.image"
                                        dense
                                        label="Slika"
                                        prepend-icon=""
                                        outlined
                                        @change="fileSelected($event)"
                                >
                                    <template v-slot:selection="{ file, index, text }">
                                        <template v-if="typeof file === 'object'">
                                            <span class="caption">{{file.name}}</span>
                                        </template>
                                        <template v-else>
                                            <span class="caption">{{file}}</span>
                                        </template>
                                    </template>
                                </v-file-input>
                            </v-col>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-card style="height: 104px;text-align: center;">
                                <v-card-text class="py-1" v-if="previewImage">
                                    <img :src="previewImage" height="95px"/>
                                </v-card-text>
                                <v-card-text class="py-1" v-else-if="selectedItem.image">
                                    <img :src="config.apiUrl + '/data/' + $store.state.site.id + '/news/' + selectedItem.id +'/'+ selectedItem.image" height="95px"/>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="selectedItem.image_name"
                            outlined
                            dense
                            label="Naziv slike"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="selectedItem.image_source"
                            outlined
                            dense
                            label="Izvor slike"
                    ></v-text-field>
                </v-col>

                <v-col cols="12" class="px-2">
                    <v-text-field
                            v-model="selectedItem.video_source"
                            outlined
                            dense
                            label="Izvor Videa"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-2">
                    <v-text-field
                            v-model="selectedItem.video"
                            outlined
                            dense
                            label="Video URL"
                    ></v-text-field>
                </v-col>

                <v-col cols="12">
                    <v-divider></v-divider>
                </v-col>


                <v-col cols="12" class="px-2 mt-4">


                    <v-tabs v-model="tab" background-color="primary" dark height="40">
                        <v-tab v-for="item in selectedItem.langs" :key="item.tab">
                            {{ item.lang.name }}
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in selectedItem.langs" :key="item.tab">
                            <v-card>
                                <v-card-text>
                                    <v-row no-gutters>

                                        <v-col cols="12" sm="12" class="px-2">
                                            <v-text-field
                                                    v-model="item.title"
                                                    dense
                                                    label="Naziv"
                                                    outlined
                                                    @input="seo(item)"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="12" class="px-2">
                                            <v-text-field
                                                    v-model="item.seo_url"
                                                    dense
                                                    label="Seo url"
                                                    outlined
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="12" class="px-2">
                                            <v-combobox
                                                    v-model="item.keywords"
                                                    dense
                                                    outlined
                                                    label="Kljucne reci"
                                                    multiple
                                                    small-chips
                                            ></v-combobox>
                                        </v-col>

                                        <v-col cols="12" sm="12" class="px-2">
                                            <v-text-field
                                                    v-model="item.meta_description"
                                                    dense
                                                    label="Meta opis"
                                                    outlined
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="12" class="px-2">
                                            <v-text-field
                                                    v-model="item.introduction"
                                                    dense
                                                    label="Uvod"
                                                    outlined
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" class="px-2">
                                            <span>Sadrzaj</span>
                                            <ckeditor  v-model="item.content" :config="editorConfig"></ckeditor>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>


                </v-col>

                <v-col cols="12" class="mt-2">
                    <v-row justify="center">
                        <v-btn color="primary" tile depressed @click="save">Snimi</v-btn>
                    </v-row>
                </v-col>

            </v-row>
        </v-col>
    </v-row>
</template>

<script>
	import bitPage from "../../components/layout/page";
	//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import config from '../../config';
    import { db } from '../../firebase';
    import axios from 'axios';

	export default {
		components: {
			bitPage
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
            config: config,
			breadcrumbs: [
				{
					text: 'Vijesti',
					disabled: false,
					to: {name: 'vijesti'},
				},
				{
					text: 'Dodavanje nove vijesti',
					disabled: true
				},
			],
			items: [],
			date: new Date().toISOString().substr(0, 10),
			date2: new Date().toISOString().substr(0, 10),
			menu: false,
            menu2: false,
			modal: false,
			/*editor: ClassicEditor,*/
			editorData: '<p>Rich-text editor content.</p>',
			editorConfig: {
                extraPlugins: 'justify'
			},
            selectedItem: {
                name: null,
                status: 1,
                langs: []
            },
            tab: null,
            categories: [],
            previewImage: null,
            news: [],
            notification: false
		}),
        created() {
            if(this.$route.params.item){
                this.getLangs();
                this.selectedItem = this.$route.params.item
                this.selectedItem.langs.forEach(lang => {
                    return lang.keywords = lang.keywords && lang.keywords.split(',')
                        ? lang.keywords.split(',') : []
                })
            }
            else{
                this.getLangs();
            }

            this.getCategory();
        },
        firestore() {
            return {
                news: db.collection('news'),
            }
        },
        methods: {
            fileSelected(evt) {
                if(evt) {
                    var reader = new FileReader()
                    reader.readAsDataURL(evt)
                    reader.onload = () => {
                        this.previewImage = reader.result;
                    };
                }
                else {
                    this.previewImage = null
                }
            },
            save() {

                this.selectedItem.category_id = this.selectedItem.category ? this.selectedItem.category.id : null;

                if(this.$route.params.item){
                    /*this.axios.put(`/news/${this.$route.params.item.id}`, this.selectedItem).then(res => {
                        this.$router.push({name: 'vijesti'})
                    })*/

                    let data = new FormData();
                    data.append('item', JSON.stringify(this.selectedItem));
                    data.append('image', this.selectedItem.image);
                    data.append('_method', 'PUT');

                    this.axios.post(`/news/${this.$route.params.item.id}`, data).then(res => {
                        if(this.notification) {
                          this.sendNotificattion(this.selectedItem.langs[0].title, this.$route.params.item.id);
                        }
                    }).finally(() => {
                      this.$router.push({name: 'vijesti-nova'})
                    })
                }
                else{
                    /*this.axios.post(`/news`, this.selectedItem).then(res => {
                        this.$router.push({name: 'vijesti'})
                    })*/

                    let data = new FormData();
                    data.append('item', JSON.stringify(this.selectedItem));
                    data.append('image', this.selectedItem.image);

                    this.axios.post(`/news`, data).then(res => {
                        if(this.notification) {
                            this.sendNotificattion(res.data.data.langs[0].name, res.data.data.id);
                        }
                    }).finally(() => {
                      this.$router.push({name: 'vijesti-nova'})
                    })
                }
            },
            getLangs() {
                this.$store.dispatch('GET_LANGUAGES').then(res => {
                    res.forEach(lang => {
                        let check = this.selectedItem.langs.find(item => item.lang_id === lang.id)
                        if(!check) {
                            this.selectedItem.langs.push({
                                title: null,
                                seo_url: null,
                                meta_description: null,
                                keywords: null,
                                introduction: null,
                                content: null,
                                lang: lang,
                                lang_id: lang.id
                            })
                        }
                    })
                })
            },
            seo(item) {
                item.seo_url = item.title.toLowerCase()
                    .replace(/ /g,'-')

                if(item.lang.lang_code != 'sr') {
                  item.seo_url.replace(/[^\w-]+/g,'')
                }
            },
            getCategory() {
                this.categories = [];
                this.axios.get(`/category/all?type=news`)
                    .then(res =>

                        res.data.forEach(item => {
                            let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                            item['name'] = lang && lang.name ? lang.name : '';
                            if (item['name'] !== '') this.categories.push(item)
                        })

                    )
            },
            sendNotificattion(title, id) {
                axios.post('https://fcm.googleapis.com/fcm/send', {
                        to: "/topics/news." + this.$store.state.site.id,
                        collapse_key: "type_a",
                        notification: {
                            title: title
                        },
                        data: {
                            site_id: this.$store.state.site.id,
                            title: title,
                            id: id
                        }
                    },
                    {
                        headers: {
                            Authorization: 'key=' + config.token
                        }
                    }
                ).then(res => {
                    console.log(res)
                })
            }
        },
        computed: {
            setLang() {
                return this.$store.state.lang.code === 'en'
                    ? 'en' : this.$store.state.lang.code === 'la'
                        ? 'sr' : 'ћи'
            }
        },
        watch: {
            setLang() {
                this.getCategory();
            }
        }
	}
</script>
